import {
    AppPermissions,
    AutoFleetEnrollmentReadPermissions,
    AutoFleetMovementRequestReadPermissions,
} from '@my-aon/auth';

import { Navigation } from '@my-aon/layout';

export const autoFleetRequestsNavigation: Navigation[] = [
    {
        title: 'AUTO_FLEET.REQUESTS.MOVEMENT.LABEL_REQUESTS',
        id: 'movement-requests',
        path: 'movement',
        requiredPermissions: AutoFleetMovementRequestReadPermissions,
    },
    {
        title: 'AUTO_FLEET.REQUESTS.COMPLETE_DATA.LABEL_REQUESTS',
        id: 'complete-data-requests',
        path: 'complete-data',
        requiredPermissionsAny: [
            AppPermissions.AUTO_FLEET_REQUESTS_COMPLETEDATA_READ_REQUESTS,
        ],
    },
];

export const autoNavigation: Navigation[] = [
    {
        title: 'AUTO_FLEET.ENROLLMENTS.PAGE_TITLE_ENROLLMENTS',
        id: 'enrollments',
        path: 'auto-fleet/enrollments',
        requiredPermissions: AutoFleetEnrollmentReadPermissions,
    },
    {
        title: 'AUTO_FLEET.REQUESTS.PAGE_TITLE_REQUESTS',
        id: 'requests',
        path: 'auto-fleet/requests',
        requiredPermissionsAny: [
            AppPermissions.AUTO_FLEET_REQUESTS_READ_REQUESTS,
            AppPermissions.AUTO_FLEET_REQUESTS_COMPLETEDATA_READ_REQUESTS,
        ],
        items: autoFleetRequestsNavigation,
    },
];
